import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import { LoginApiRequest } from '@/data/payload/api/AuthRequest'
import store from '@/app/store/store'
import { AuthPresenter } from '@/app/ui/presenters/AuthPresenter'
import { Admin, Token, Menu } from '@/domain/entities/Admin'
import {
  setCredential,
  getToken,
  removeAuthCredential,
  getUserRolePermission,
  setUserRolePermission,
  setSalesCode,
  getSalesCode,
} from '@/utils/cookies'
import router from '@/router'
import Vue from 'vue'

export interface AuthState {
  authData: Admin
  isLoading: boolean
  salesCode: any
  token: string
  menu: Menu[]
}

@Module({ namespaced: true, dynamic: true, store, name: 'auth' })
class Auth extends VuexModule implements AuthState {
  public menu = JSON.parse(getUserRolePermission()) || []
  public authData: Admin = new Admin(
    0,
    '',
    '',
    '',
    '',
    false,
    1,
    [],
    new Token('', 0)
  )
  public salesCode = getSalesCode() ? JSON.parse(getSalesCode()) : ''
  public isLoading = false
  public token = getToken() || ''

  @Action
  public sendLogin(params: { email: string; password: string }) {
    this.setLoading(true)
    const presenter = container.resolve(AuthPresenter)
    presenter
      .onLogin(new LoginApiRequest(params.email, params.password))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Login',
          message: 'Login Success',
          type: 'success',
          duration: 3000,
        })
        this.setAuthData(res)
        this.setToken(res.token.accessToken || '')
        this.setMenu(res.menu || [])
        this.setSales(res.profile || '')
        router.push('/dashboard')
      })
      .catch((error) => {
        Vue.prototype.$notify({
          title: 'Login',
          message: 'Wrong Email or Password',
          type: 'error',
          duration: 3000,
        })
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public logOut() {
    removeAuthCredential()
    this.setToken('')
    this.setMenu([])
  }

  @Mutation
  private setAuthData(admin: Admin) {
    this.authData = new Admin(
      0,
      '',
      '',
      '',
      '',
      admin.profile,
      1,
      admin.menu,
      admin.token
    ) // save temporary in Vuex State
    setCredential({
      token: admin.token.accessToken,
      expired: admin.token.expiredAt,
    })
    setUserRolePermission(admin.menu)
    setSalesCode(admin.profile)
  }

  @Mutation
  private setLoading(bool: boolean) {
    this.isLoading = bool
  }

  @Mutation
  private setToken(token: string) {
    this.token = token
  }

  @Mutation
  private setMenu(roleMenu: any) {
    this.menu = roleMenu
  }

  @Mutation
  private setSales(salesCode: any) {
    this.salesCode = salesCode
  }
}

export const AuthModule = getModule(Auth)
